import { render, staticRenderFns } from "./Fasilitas.vue?vue&type=template&id=130e069e&scoped=true&"
import script from "./Fasilitas.vue?vue&type=script&lang=js&"
export * from "./Fasilitas.vue?vue&type=script&lang=js&"
import style0 from "./Fasilitas.vue?vue&type=style&index=0&id=130e069e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130e069e",
  null
  
)

export default component.exports